import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'mapsindoor',
    name: "MapsIndoors",
    description: 'A widget to show MapsIndoors and get directions',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-mapsindoor" */ "./MapsIndoorCardTemplate")),
    icon: generateIconProp('map'),
    complexity: 'medium',
});
